import { supabase } from './supabaseClient';

export const getSecurePDFUrl = async (fileName) => {
  try {
    const { data, error } = await supabase.storage
      .from('pdfs')
      .createSignedUrl(fileName, 3600); // URL expires in 1 hour

    if (error) throw error;
    return data.signedUrl;
  } catch (error) {
    //console.error('Error getting secure PDF URL:', error);
    throw error;
  }
};